import { render, staticRenderFns } from "./PICDash.vue?vue&type=template&id=3c28efe0&scoped=true"
import script from "./PICDash.vue?vue&type=script&lang=js"
export * from "./PICDash.vue?vue&type=script&lang=js"
import style0 from "./PICDash.vue?vue&type=style&index=0&id=3c28efe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28efe0",
  null
  
)

export default component.exports